/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the ShivaGNVertSecuredConfiguration configuration object with a given root URL.
 */
export function provideShivaGNVertSecuredConfiguration(rootUrl: string) {
  var config = new ShivaGNVertSecuredConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: ShivaGNVertSecuredConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ShivaGNVertSecuredConfiguration {
  rootUrl: string = '/web';
}

